import { apiClient } from "../api-client";
import type { paths } from "../api-types";

type EventFilters = paths["/api/public/events"]["get"]["parameters"]["query"];

export function useEvents(filters?: EventFilters) {
  return apiClient.useQuery(
    "get",
    "/api/public/events",
    {
      params: {
        query: filters,
      },
    },
    {
      // Keep previous data while fetching new data to avoid flashing loading states
      placeholderData: (previousData) => previousData,
      staleTime: 1000 * 60 * 5, // 5 minutes - avoid refetch on every window focus
    },
  );
}

export function useEvent(id: string | undefined) {
  return apiClient.useQuery(
    "get",
    "/api/public/events/{id}",
    {
      params: {
        path: {
          id: id!,
        },
      },
    },
    {
      enabled: !!id,
    },
  );
}






